import gql from 'graphql-tag'

export const CREATE_BARCODE_PRODUCT = gql`
  mutation CreateBarcodeProduct(
    $data: BarcodeProductCreateInput!
    $cover: Upload
  ) {
    createBarcodeProduct(data: $data, cover: $cover) {
      id
      name
    }
  }
`

export const UPDATE_BARCODE_PRODUCT = gql`
  mutation UpdateBarcodeProduct(
    $id: Int!
    $data: BarcodeProductUpdateInput!
    $cover: Upload
  ) {
    updateBarcodeProduct(id: $id, data: $data, cover: $cover) {
      id
      name
    }
  }
`

export const DELETE_BARCODE_PRODUCT = gql`
  mutation DeleteBarcodeProduct($id: Int!) {
    deleteBarcodeProduct(id: $id) {
      id
    }
  }
`
